/* eslint-disable */
import PropTypes from 'prop-types';
import EntriesContextPropTypes from '../../Contexts/Entries/Entries.props';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const PagePropTypes = {
  /**
   * The content of the Page
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The description of the page
   */
  description: PropTypes.string,

  /**
   * The current `entry`
   */
  entry: EntriesContextPropTypes.entry.isRequired,

  /**
   * The i18n key to be looked up and then displayed in the <Navbar />
   */
  heading: PropTypes.string,

  /**
   * The optional data to be supplied to the i18n `heading`
   */
  headingData: PropTypes.object,

  /**
   * Whether or not to hide the sidebar
   */
  hideSidebar: PropTypes.bool,

  /**
   * The `padding` that should be applied to the page
   */
  padding: PropTypes.oneOf([`dense`, `none`, `normal`]),

  /**
   * The extensions for the Navbar
   */
  renderExtensions: PropTypes.node,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,

  /**
   * The contextually aware content to render on the sidebar
   */
  sidebar: PropTypes.func,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The i18n key to be looked up and then displayed in the `<title />`
   */
  title: PropTypes.string.isRequired,

  /**
   * The optional data to be supplied to the i18n `title`
   */
  titleData: PropTypes.object,
};

export default PagePropTypes;
